import {useContext} from "react";
import AppMenu from "./AppMenu";
import {LayoutContext} from "./context/LayoutContext";
import {MenuProvider} from "./context/menucontext";
import {LayoutState} from "../types";
import {useNavigate} from "react-router-dom";

const AppSidebar = () => {
    const { setLayoutState } = useContext(LayoutContext);
    const anchor = () => {
        setLayoutState((prevLayoutState: LayoutState) => ({
            ...prevLayoutState,
            anchored: !prevLayoutState.anchored,
        }));
    };

    const navigate = useNavigate();
    return (
        <>
            <div className="sidebar-header">

                <div className="app-logo" onClick={() => {
                    navigate('/')
                }}>
                    <img
                        src={`/logo.png`}
                        className={"app-logo-normal w-10rem  h-full cursor-pointer"}
                        alt={"logo"}
                    />

                    <img src="/logo-symbool.png" alt="Logo" height="27"
                         className="app-logo-small" onClick={() => {
                        // router.push('/')
                    }}/>
                </div>
                <button
                    className="layout-sidebar-anchor p-link z-2 mb-2"
                    type="button"
                    onClick={anchor}
                ></button>
            </div>

            <div className="layout-menu-container">
                <MenuProvider>
                    <AppMenu />
                </MenuProvider>
            </div>
        </>
    );
};

export default AppSidebar;
